import { CommonModule, registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import localeDe from "@angular/common/locales/de";
import { APP_INITIALIZER, Injector, LOCALE_ID, NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { AtlasTranslateModule } from "@asfinag/atlas";
import { JwtModule } from "@auth0/angular-jwt";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "src/environments/environment";

import { appInitializerFactory } from "./app-initializer-factory";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { JWT_MODULE_OPTIONS } from "./config/auth.config";
import { TRANSLATE_CONFIG } from "./config/translate.config";
import { HeaderComponent } from "./core/header/header.component";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { VersionInterceptor } from "./interceptors/version-interceptor";
import { API_BASE_URL } from "./services/bbo-client.service";
import { DigitalRoadworkAtlasModule, DigitalRoadworkMaterialModule } from "./shared/modules";
import { SharedModule } from "./shared/shared.module";
import { CustomRouteReuseStrategy } from "./shared/utils/route-reuse-strategy";

registerLocaleData(localeDe);
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
	declarations: [AppComponent, HeaderComponent],
	imports: [
		CommonModule,
		SharedModule,
		MatButtonModule,
		DigitalRoadworkAtlasModule,
		DigitalRoadworkMaterialModule,
		AtlasTranslateModule.forRoot(TRANSLATE_CONFIG),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		BrowserModule,
		AppRoutingModule,
		ServiceWorkerModule.register("ngsw-worker.js", {
			enabled: environment.production,
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: "registerWhenStable:30000",
		}),
		BrowserAnimationsModule,
		JwtModule.forRoot(JWT_MODULE_OPTIONS),
	],
	providers: [
		{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
		{ provide: LOCALE_ID, useValue: navigator.language },
		{ provide: API_BASE_URL, useValue: environment.apiRoot },
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializerFactory,
			deps: [TranslateService, Injector],
			multi: true,
		},
		{ provide: HTTP_INTERCEPTORS, useClass: VersionInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
